import { BaseService } from '../../../global/classes';
import { bffApi } from '../../../services/bff/bffApi';

import { SplashDTO } from '../types';

export class SplashService extends BaseService {
  getSplash = async (userId: string): Promise<SplashDTO | null> => {
    const response = await bffApi.get(
      `/api/struct/v1/splashes/active/pending-acceptance`,
      {
        params: { userId },
      }
    );

    return response.data ?? null;
  };

  markSplashNotAccepted = async (splashId: number, userId: string): Promise<SplashDTO> => {
    const response = await bffApi.patch(
      `/api/struct/v1/splashes/${splashId}/not-accepted`,
      null,
      {
        params: { userId },
      }
    );

    return response.data;
  };
}